import { TaskStatus } from '@nexelem/graphne-api';

type AllowedMove = {
  fromStatus?: TaskStatus;
  toStatus?: TaskStatus;
};

export const isAllowedMoveQueue = ({ toStatus, fromStatus }: AllowedMove) => {
  if (fromStatus && toStatus) {
    return allowedMoves[fromStatus]?.includes(toStatus);
  }
  return false;
};

const allowedMoves: Partial<Record<TaskStatus, TaskStatus[]>> = {
  [TaskStatus.Pending]: [TaskStatus.Pending, TaskStatus.InProgress],
  [TaskStatus.InProgress]: [TaskStatus.Pending, TaskStatus.InProgress, TaskStatus.Completed],
  [TaskStatus.Completed]: [TaskStatus.Completed],
};
